(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mag-first-order"] && !Shopify.designMode) return;
  try {
    
function initMag(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const end=Date.parse(root.dataset.end),timer=root.querySelector('[data-countdown]'),labels=root.querySelector('[data-labels]').dataset,button=root.querySelector('[data-add]'),form=root.querySelector('form'),select=root.querySelector('[data-variant]');
 const tick=()=>{const left=Math.max(0,Math.floor((end-Date.now())/1000));root.querySelector('[data-offer]').hidden=!left;root.querySelector('[data-expired]').hidden=!!left;root.querySelector('[data-code-note]').hidden=!left;root.querySelector('[data-terms]').hidden=!left;if(!button.disabled)button.textContent=left?button.dataset.active:button.dataset.normal;timer.replaceChildren(...[Math.floor(left/86400),Math.floor(left/3600)%24,Math.floor(left/60)%60,left%60].map((n,i)=>{const span=document.createElement('span'),b=document.createElement('b');b.textContent=String(n).padStart(2,'0');span.append(b,document.createTextNode([labels.days,labels.hours,labels.minutes,labels.seconds][i]));return span;}));};tick();const clock=setInterval(()=>{if(!root.isConnected){clearInterval(clock);return;}tick();},1000);
 const galleryButtons=[...root.querySelectorAll('[data-gallery-image]')],photo=root.querySelector('.mag-photo'),image=photo.querySelector('img'),caption=root.querySelector('[data-gallery-caption]');
 const showGallery=target=>{image.removeAttribute('srcset');image.src=target.dataset.galleryImage;image.alt=target.dataset.galleryAlt;caption.textContent=target.dataset.galleryCaption;photo.toggleAttribute('data-lifestyle',!target.hasAttribute('data-gallery-product'));galleryButtons.forEach(button=>button.setAttribute('aria-pressed',String(button===target)));};
 galleryButtons.forEach(target=>target.addEventListener('click',()=>showGallery(target)));
 select.addEventListener('change',()=>{const option=select.selectedOptions[0];root.querySelector('.mag-buy-row [data-price]').textContent=option.dataset.money;const productButton=root.querySelector('[data-gallery-product]');productButton.dataset.galleryImage=option.dataset.image;productButton.dataset.galleryAlt=option.textContent;productButton.dataset.galleryCaption=productButton.getAttribute('aria-label')+': '+option.textContent;const thumb=productButton.querySelector('img');thumb.removeAttribute('srcset');thumb.src=option.dataset.image;showGallery(productButton);});
 form.addEventListener('submit',async event=>{event.preventDefault();if(button.disabled)return;button.disabled=true;button.textContent=button.dataset.busy;root.querySelector('[data-error]').hidden=true;try{const response=await fetch(root.dataset.root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!response.ok)throw Error('cart');const redirect=root.dataset.root+'checkout';location.assign(Date.now()<end?root.dataset.root+'discount/'+encodeURIComponent(root.dataset.code)+'?redirect='+encodeURIComponent(redirect):redirect);}catch{root.querySelector('[data-error]').hidden=false;button.disabled=false;tick();}});
}
document.querySelectorAll('[data-mag-page]').forEach(initMag);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mag-page]').forEach(initMag));

  } catch(e) { console.error(e); }
})();
})();
